<template>
  <button
    type="button"
    :title="langStore.locale === 'en' ? 'Switch to Arabic' : 'التبديل إلى الإنجليزية'"
    :class="[
      'inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-semibold transition-all duration-150',
      variant === 'dark'
        ? 'bg-white/5 hover:bg-white/10 text-slate-300 border border-white/10'
        : 'bg-muted hover:bg-muted/80 text-muted-foreground border border-border'
    ]"
    @click="toggle"
  >
    <Globe class="w-3.5 h-3.5 shrink-0" />
    <span>{{ langStore.locale === 'en' ? 'AR' : 'EN' }}</span>
  </button>
</template>

<script setup>
import { Globe } from 'lucide-vue-next'
import { useI18n } from 'vue-i18n'
import { useLanguageStore } from '@/stores/language'

defineProps({ variant: { type: String, default: 'light' } })

const { locale } = useI18n()
const langStore  = useLanguageStore()

const toggle = () => {
  langStore.toggle()
  locale.value = langStore.locale
}
</script>
